// extracted by mini-css-extract-plugin
export default {"PublicRouteWrapper":"styles_PublicRouteWrapper__Yt3M8","PublicRouteWrapper-peopleBackground":"styles_PublicRouteWrapper-peopleBackground__twGtc"};